import React from "react";
const cx = (...a) => a.filter(Boolean).join(" ");
export default function Button({ variant = "primary", className, ...props }) {
  return (
    <button
      className={cx(
        "btn",
        variant === "secondary" && "secondary",
        variant === "ghost" && "ghost",
        className
      )}
      {...props}
    />
  );
}
